import { defineStore } from "pinia";
import { Site, SiteData } from "@/types/v2";
import { SitesService } from "@/services/v2/sites";
import { SitesStorageService } from "@/services/v2/sites/storage";

export const useSitesStore = defineStore({
  id: "sites",
  state: (): SiteData => ({
    sites: [],
    activeSiteId: null as null | string,
    activeSite: null as Site | null,
  }),
  getters: {
    getSites(state) {
      return state.sites;
    },
    getActiveSiteId(state) {
      return state.activeSiteId;
    },
  },
  actions: {
    async init() {
      return this.setSites(await SitesService.getUserSites());
    },

    setSites(sites: Site[]) {
      this.sites = sites;
    },
    // Set active site id
    async setActiveSite(key: string) {
      let site: Site | null | undefined = null;

      if (key !== null) {
        this.activeSiteId = key;
        site = this.sites.find((s) => s.key === key);
        // site from store
        if (site) {
          this.activeSite = site;
          return SitesStorageService.storeActiveSite(site);
        } else {
          const sites = await SitesService.getUserSites();
          if (sites) {
            this.setSites(sites);
          }

          site = sites.find((s) => s.key === key);
          if (site) {
            this.activeSite = site;
          }
        }

        return null;
      }
      // site from index db
      site = await SitesStorageService.getActiveSite();
      if (site) {
        this.activeSite = site;
      }
    },
  },
});
